require('./vmConfiguration.style.scss');

const HELP_ID = { EXCLUDED: 'exclude_disks', PREPOST: 'prepost_scripts', FLR: 'flr' },
    DEFAULT_PATH = {
        WINDOWS: {
            PRE_SNAPSHOT: 'C:\\ProgramData\\Hycu\\presnapshot.cmd',
            POST_SNAPSHOT: 'C:\\ProgramData\\Hycu\\postsnapshot.cmd',
        },
        LINUX: {
            PRE_SNAPSHOT: '/opt/hycu/presnapshot.sh',
            POST_SNAPSHOT: '/opt/hycu/postsnapshot.sh',
        },
    };

class VmConfigurationController {
    constructor(
        $scope,
        $element,
        $timeout,
        $q,
        $filter,
        $rootScope,
        virtualMachinesPersistence,
        notificationService,
        utilsService,
        validationsService
    ) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.persistence = virtualMachinesPersistence;
        this.notificationService = notificationService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;

        this.pathPatern = this.validationsService.getPrePostScriptPattern();
        this.pathPatternMessageWindows = this.$filter('translate')(
            'vm.configuration.script.path.validationMessage.windows'
        );
        this.pathPatternMessageLinux = this.$filter('translate')(
            'vm.configuration.script.path.validationMessage.linux'
        );
        this.showSnapshotScriptDialog = false;
    }

    $onInit() {
        this.configTable();
        this.modalTitle = this.$filter('translate')('vm.configuration.title');
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.save.label'),
                action: () => this.save(),
                isDisabled: () => this.isDisabled(),
            },
        ];
        this.disks = [];

        this.DEFAULT_OS = this.utilsService.getDefaultOS();
    }

    isDisabled() {
        return (
            this.busy ||
            !this.dialogForm ||
            !this.dialogForm.$valid ||
            (this.previousActiveTab && !this.tabsFormValid['tab0'])
        );
    }

    configTable() {
        this.columnNames = [
            this.$filter('translate')('vm.configuration.excludeFromBackup.grid.header.deviceBus.newLabel'),
            this.$filter('translate')('vm.configuration.excludeFromBackup.grid.header.size'),
            this.$filter('translate')('vm.configuration.excludeFromBackup.grid.header.uuid'),
        ];
    }

    baseInitialization() {
        this.activeTab = 1;
        this.previousActiveTab = null;
        this.tabsFormValid = {};
        this.busy = null;
        this.os = null;
        this.disks = [];
        this.selectedDisks = [];
        this.vmDisks = [];
        this.selectedVmDisks = [];
        this.vmPathPattern = null;
        this.vmPathPatternMessage = null;
        this.preSnapshotScript = { path: null };
        this.postSnapshotScript = { path: null };
        this.isSetScriptsAvailable = null;
        this.vmNotDiscovered = null;
        this.helpId = HELP_ID.PREPOST;

        this.diskWatcher = this.$scope.$watch(
            () => this.selectedDisks,
            (newVal, oldVal) => {
                this.encryptedDiskIncluded = false;
                this.disks.forEach((disk) => {
                    // disk.excluded = disk.os ? true : false;
                    if (!this.selectedDisks.indexOf(disk) !== -1) {
                        if (disk.isEncrypted) {
                            this.encryptedDiskIncluded = true;
                        }
                    }
                });
            }
        );
    }

    copyToClipboard(uuid, event) {
        event.stopPropagation();
        let div = document.createElement('div');
        div.id = 'temp-element';
        div.innerHTML = uuid;
        document.getElementById('exclude-backup').appendChild(div);
        this.utilsService.copyToClipboard('temp-element', 'UUID');
        document.getElementById('exclude-backup').removeChild(div);
    }

    setGrid(grid) {
        this.grid = grid;
        this.gridColumnsStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: [],
        };
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('5%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('48%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('34%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('13%');

        this.gridFlag = true;
    }

    onOpen() {
        this.baseInitialization();
        this.load();
    }

    load() {
        this.busy = true;

        this.persistence.setVirtualMachineDetails(this.chosenVm[0]).then((virtualMachine) => {
            this.selectedVm = virtualMachine;
            this.managed = this.selectedVm ? this.selectedVm.managed : false;
            this.persistence.getVirtualMachineConfiguration(this.selectedVm.uuid).then((res) => {
                if (!res) return;
                this.configResponse = res;
                this.prepareDisksForDisplay(this.configResponse);
                this.isSetScriptsAvailable = this.selectedVm.discoveryStatus === 'OK';
                this.vmNotDiscovered = this.isSelectedVmNotDiscoverable();
                this.enableCatalog = res.catalogCreation;
                this.os = this.utilsService.getOSType(this.selectedVm.operatingSystem);
                this.vmPathPattern =
                    this.os === this.DEFAULT_OS.WINDOWS
                        ? this.pathPatern.WINDOWS
                        : this.os === this.DEFAULT_OS.LINUX
                        ? this.pathPatern.LINUX
                        : null;
                this.vmPathPatternMessage =
                    this.os === this.DEFAULT_OS.WINDOWS
                        ? this.pathPatternMessageWindows
                        : this.os === this.DEFAULT_OS.LINUX
                        ? this.pathPatternMessageLinux
                        : null;

                this.prepareScriptsForDisplay(res);
                this.busy = false;
            });
        });
    }

    save() {
        this.busy = true;
        let data = {
            catalogCreation: this.enableCatalog,

            disks: this.disks.map((disk) => {
                return {
                    uuid: disk.uuid,
                    name: disk.name,
                    isExcluded: this.selectedDisks.indexOf(disk) !== -1 ? true : false,
                };
            }),

            preSnapshotCommand: this.preSnapshotScript.path,
            postSnapshotCommand: this.postSnapshotScript.path,
        };
        this.persistence.saveVirtualMachineConfiguration(this.selectedVm.uuid, data).then(
            (res) => {
                this.busy = false;
                this.notificationService.pop(res.data.message);
                this.showModal = false;
            },
            (err) => {
                this.busy = false;
            }
        );
    }

    onTabChange(previous, active) {
        return this.$q((resolve) => {
            if (previous !== active) {
                this.previousActiveTab = previous;
                this.tabsFormValid[previous] = this.dialogForm.$valid;
            }
            if (active == 'tab1') {
                this.helpId = HELP_ID.EXCLUDED;
                // this.selectedDisks = this.disks.filter((disk) => disk.isExcluded);
                this.prepareDisksForDisplay(this.configResponse);
            } else if (active == 'tab0') {
                this.prepareDisksForDisplay(this.configResponse);
                this.helpId = HELP_ID.PREPOST;
            } else {
                this.prepareDisksForDisplay(this.configResponse);
                this.helpId = HELP_ID.FLR;
            }
            resolve();
        });
    }

    prepareDisksForDisplay(res) {
        if (res && this.disks.length === 0) {
            this.disks = res.disks;
            this.selectedDisks = this.disks.filter((disk) => disk.isExcluded);
        }
    }

    prepareScriptsForDisplay(item) {
        this.preSnapshotScript.path = item.preSnapshotCommand;
        this.postSnapshotScript.path = item.postSnapshotCommand;
    }

    getScriptPath(path, os, preSnapshot, postSnapshot) {
        if (path) return path;
        if (!os || (os !== this.DEFAULT_OS.WINDOWS && os !== this.DEFAULT_OS.LINUX)) return null;
        return preSnapshot ? DEFAULT_PATH[os].PRE_SNAPSHOT : postSnapshot ? DEFAULT_PATH[os].POST_SNAPSHOT : null;
    }

    onClose() {
        this.disks = [];
        this.diskOptions = [];
        this.enableCatalog = null;
    }

    isSelectedVmNotDiscoverable() {
        if (this.selectedVm.discoveryStatus !== 'OK') {
            return true;
        } else return false;
    }
}

VmConfigurationController.$inject = [
    '$scope',
    '$element',
    '$timeout',
    '$q',
    '$filter',
    '$rootScope',
    'virtualMachinesPersistence',
    'notificationService',
    'utilsService',
    'validationsService',
];

const vmConfigurationComponent = {
    controller: VmConfigurationController,
    template: require('./vmConfiguration.template.html'),
    bindings: {
        showModal: '=',
        onClosed: '&onClose',
        chosenVm: '=',
    },
};

module.exports = vmConfigurationComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/vmConfiguration/vmConfiguration.component.js